import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/animations.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installSessionTracking } from './utils/session';

// Before the first render, so no request can go out untagged. Adds X-Session-ID
// to gateway-bound fetch() calls; the axios client sets it on its own requests.
installSessionTracking();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// Retire the pre-JS still frame from index.html now that React owns the screen.
//
// Deferred by two frames, NOT run straight after render(): createRoot().render()
// only *schedules* the initial mount, so on this line the DOM is still empty.
// Clearing the frame here would uncover a blank page and undo the whole point of
// having it. Two rAFs put us safely past React's commit and its first paint.
//
// Faded rather than yanked so it dissolves into whatever mounted underneath —
// on the landing route that is the identical cap-ring, so the swap is invisible.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const initialLoader = document.getElementById('initial-loader');
    if (!initialLoader) return;
    initialLoader.classList.add('hidden');
    setTimeout(() => initialLoader.remove(), 300);
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
